/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */

type CodeForEvaluationDataType = {
	code: string;
	tests?: string | null;
	name: string;
};

export const getJsCodeForEvaluation = (data: CodeForEvaluationDataType) => {
	const { code, tests, name } = data;

	const __cwt__makeCodeClean = (codeString: string) => {
		codeString = codeString.replaceAll(/alert/gi, '__cwt__noEffect');
		codeString = codeString.replaceAll(/console.log/gi, '__cwt__consoleLog');
		return codeString;
	};
	const __cwt__cleanCode = __cwt__makeCodeClean(code);
	const __cwt__hasTests = !!tests;
	const allCode = `
	const __cwt__response = { logs: [], result: null, tests: [], errors: [] };
	const __cwt__jsTests = ${__cwt__hasTests};
	const __cwt__message = {
		source: '__cwt__jstests__${name}',
		payload: __cwt__response
	};
	function __cwt__noEffect() {}
	let __cwt__message__inited = false;
	let __cwt__consoleLog = function() {
		const args = Array.prototype.slice.call(arguments);
		
		const res = args.map((arg) => {
			console.log(arg);
			console.log(typeof arg);

			// TODO: recursive logs like: {type: 'string', value: value}
			
			if (typeof arg === 'object') {
				if(arg === null) {
					return 'null';
				}
				if (Object.getPrototypeOf(arg) === Map.prototype) {
					function MapReplacer(key, value) {
						if(value instanceof Map) {
						  return Array.from(value.entries());
						} else {
						  return value;
						}
					}
					const mapStringified = JSON.stringify(arg, MapReplacer);
					return "Map: " + mapStringified;
				}
				if (arg instanceof Set) {
					const setStringified = JSON.stringify(
						arg,
						(_key, value) => (value instanceof Set ? [...value] : value)
					);
					return "Set: " + setStringified;
				}
				if(arg instanceof WeakMap) {
					return "[object WeakMap]";
				}
				if(arg instanceof WeakSet) {
					return "[object WeakSet]";
				}
				if(arg.outerHTML) {
					return "[object HTMLElement]";
				}
				return JSON.stringify(arg);
			}
			if (typeof arg === 'undefined') {
				return 'undefined';
			}
			return arg;
		});
		__cwt__response.logs.push(res.join(' '));
		window.parent.postMessage(__cwt__message, '*');
	}
	function __cwt__testOptions() {
		// __cwt__consoleLog = __cwt__noEffect;
	}

	try {
		${__cwt__cleanCode}
		const __cwt__tests = [];
		const __cwt__test = (testData) => {
			__cwt__tests.push({
				name: testData.name,
				pass: testData.test,
				input: testData.input,
    			expectedResult: testData.expectedResult,
				actualResult: __cwt__result
			})
		};
		if(__cwt__testOptions) {
			__cwt__testOptions();
		}
		${tests};
		if(__cwt__jsTests && __cwt__result) {
			__cwt__response.result = __cwt__result;
		}
		if(__cwt__jsTests && __cwt__tests) {
			__cwt__response.tests = __cwt__tests;
		}
		const __cwt__message = {
			source: '__cwt__jstests__${name}',
			payload: __cwt__response
		};
		__cwt__message__inited = true;
		window.parent.postMessage(__cwt__message, '*');
	} catch(e) {
		__cwt__response.errors = [e];
		const __cwt__message = {
			source: '__cwt__jstests__${name}',
			payload: __cwt__response
		};
		window.parent.postMessage(__cwt__message, '*');
	}
	`;
	return allCode;
};

export default getJsCodeForEvaluation;
